module.exports = __webpack_public_path__ + "img/menu4.697f459b.png";